import { ReviewProduct } from './ReviewProduct';
import { copyUsableValues } from '../../utils/UsableValues';

interface IReviewComponents {
    ReviewSnippet?: string;
    ReviewImageSnippet?: string;
    ReviewDetails?: string;
}

export interface IReviewDetailsData {
    apiKey: string;
    merchantId: string;
    merchantGroupId: string;
    locale: string;
    pageId: string;
    name: string;
    imageUrl: string;
    description: string;
    categoryName: string;
    manufacturerId?: string;
    upc?: string;
    brandName?: string;
    price?: string;
    inStock?: boolean;
    url: string;
    reviewWrapperUrl: string;
    components?: IReviewComponents;
    onRender?(): boolean;
    onSubmit?(): boolean;
}

export class ReviewDetails {
    public api_key: string;
    public merchant_id: string;
    public merchant_group_id: string;
    public locale: string;
    public page_id: string;
    public product: string;
    public review_wrapper_url: string;
    public components: IReviewComponents;
    public on_render: void;
    public on_submit: void;

    public static toJson(data: IReviewDetailsData) {
        const reviewDetails = new ReviewDetails();
        const mappingData = {
            api_key: data.apiKey,
            merchant_id: data.merchantId,
            merchant_group_id: data.merchantGroupId,
            locale: data.locale,
            page_id: data.pageId,
            product: ReviewProduct.toJson(data),
            review_wrapper_url: data.reviewWrapperUrl,
            components: data.components,
            on_render: data.onRender,
            on_submit: data.onSubmit
        };
        copyUsableValues(mappingData, reviewDetails);

        return reviewDetails;
    }
}
